import { useTranslation } from 'react-i18next'
import { Link, useNavigate } from 'react-router-dom'
import { FreeReportSetupError, useStartFreeReport } from '../api/hooks'
import { problemOf } from '../api/client'

/** Translates a failed "start free report" attempt: missing SERBEST template / company, or the API's ProblemDetails title. */
export function useFreeStartError(error: unknown): string | null {
  const { t } = useTranslation()
  if (!error) return null
  if (error instanceof FreeReportSetupError) return t(error.code === 'template_missing' ? 'freeReport.templateMissing' : 'freeReport.companyMissing')
  return problemOf(error).title ?? t('freeReport.startFailed')
}

/**
 * /reports/free (sidebar "Boş Rapor") and /reports/new?free=1: asks for a confirmation, then creates the SERBEST draft and
 * goes to its item editor. Nothing is created by merely opening the page (a stray click on the menu must not leave a draft).
 */
export default function StartFreeReportPage() {
  const { t } = useTranslation()
  const navigate = useNavigate()
  const start = useStartFreeReport()
  const { mutate } = start
  const message = useFreeStartError(start.error)
  const begin = () => mutate(undefined, { onSuccess: (created) => navigate(`/reports/${created.id}/free`, { replace: true }) })

  return (
    <div className="card stack" style={{ maxWidth: 560 }}>
      <h2 style={{ margin: 0 }}>{t('freeReport.title')}</h2>
      <p style={{ margin: 0 }}><b>{t('freeReport.startConfirmTitle')}</b></p>
      <p className="muted" style={{ margin: 0 }}>{t('freeReport.startConfirmText')}</p>
      {start.isError ? <p className="error" style={{ margin: 0 }}>{message}</p> : null}
      <div className="row wrap">
        <button onClick={begin} disabled={start.isPending}>{start.isPending ? t('freeReport.starting') : start.isError ? t('freeReport.retry') : t('freeReport.startButton')}</button>
        <Link className="button secondary" to="/reports">{t('common.cancel')}</Link>
      </div>
    </div>
  )
}
